import { render, staticRenderFns } from "./SubmitEPUAP.vue?vue&type=template&id=1ba33d5e&"
import script from "./SubmitEPUAP.vue?vue&type=script&lang=js&"
export * from "./SubmitEPUAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports